import { render, staticRenderFns } from "./GeoViz.vue?vue&type=template&id=2bd8c84d&scoped=true"
import script from "./GeoViz.vue?vue&type=script&lang=ts"
export * from "./GeoViz.vue?vue&type=script&lang=ts"
import style0 from "./GeoViz.vue?vue&type=style&index=0&id=2bd8c84d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd8c84d",
  null
  
)

export default component.exports